import React from "react";

const Avatar: React.FC = () => (
  <div className="level" style={{ paddingBottom: "1em" }}>
    <img className="avatar" src="/img/ush-sml-pxl-rounded.png" alt="avatar" />
  </div>
);

export default Avatar;
